/*
 * Maintain a connection to the websocket to get live updates
 */
// eslint-disable-next-line
import util from 'util';
import * as PortalApi from './PortalApi';
import * as coreSelectors from './core/selectors';
import * as coreActions from './core/actions';
import * as serviceActions from './service/actions';
import * as accountActions from './account/actions';

// eslint-disable-next-line  
var store = null;
var socket = null;
var open = false;
var pinger = null;

/*
 * Call at page load to set the store and make the initial connection 
 */
export function setup(thestore) {
  store = thestore;
  Connect();
}

/* 
 * Call to push an updated event subscription to the server
 */
export function Subscribe() {
  if (open) {
    let subscription = { sessionKey: coreSelectors.getSessionKey(store.getState()) };
    socket.send(JSON.stringify(subscription));
  }
}


/*
 * Connect and set callbacks 
 */
export function Connect() {
  socket = new WebSocket(PortalApi.WebSocket());
  socket.onopen = opened;
  socket.onclose = closed;
  socket.onmessage = message;
}

/*
 * Send a ping to keep the connection alive
 */
export function Ping() {
  if (open) {
    socket.send('PING');
  }
}

/*
 * Call actions based on event object received
 */
function message(event) {
  // eslint-disable-next-line    
  let data = JSON.parse(event.data);
  /* Update is all we can get right now */
  if (data.update) {
    store.dispatch(coreActions.updateUser());
    store.dispatch(
      serviceActions.querySmsTasks({ background: true, useFilterDays: true })
    );
    store.dispatch(serviceActions.getAllMessages());
    store.dispatch(accountActions.pushUpdate());
  }

}

/*
 * If closed, try to reconnect after a 5 second wait 
 */
function closed() {
  util.log("Websocket Closed");
  open = false;
  setTimeout(function() {
    Connect();
  }, 5000);
}

/*
 * New socket opened, send the subscription info
 */
function opened() {
  util.log("Websocket open");
  open = true;
  /* Ping it every 45 seconds as it likes to close it after 60 seconds of idle */
  if (pinger === null) {
    pinger = setInterval(Ping, 45000);
  }
  Subscribe();
}
